import { render, staticRenderFns } from "./index-customer-v2.vue?vue&type=template&id=3bd40860&"
import script from "./index-customer-v2.vue?vue&type=script&lang=js&"
export * from "./index-customer-v2.vue?vue&type=script&lang=js&"
import style0 from "./index-customer-v2.vue?vue&type=style&index=0&id=3bd40860&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports